export interface Person {
  ID?: Readonly<string>;
  SocialSecurityNumber: string;
  Revision?: Readonly<number>;
  CreatedAt?: Readonly<string>;
  UpdatedAt?: Readonly<string>;
  Country?: string;
  FirstName?: string;
  LastName?: string;
  LivedAtAddressSince?: string;
  AddressType?: AddressType;
  Street?: string;
  StreetNumber?: string;
  StreetLevel?: string;
  StreetDoorSide?: string;
  ZipCode?: string;
  City?: string;
  MarketCountry?: string;
  Deceased?: boolean;
  ProtectedIdentity?: boolean;
  Sex?: 'M' | 'F';
  Age?: number;
  HasCompleteAddress?: boolean;
  HasCompleteName?: boolean;
  Fraud?: boolean;
  CreditWarning?: boolean;
}

export enum AddressType {
  AddressSpecial = 'Special',
  AddressAbroad = 'Abroad',
  AddressCo = 'Co',
  AddressBox = 'Box',
  AddressPosteRestante = 'Poste Restante',
  AddressFack = 'Fack',
}

export type Patch = {
  id: string;
  data: Partial<Person>;
};

type NullableAndOptionalProps<T> = {
  [K in keyof T]?: T[K] | null;
};

export type UpdatePerson = NullableAndOptionalProps<Person>;
